import Model from "@/models/Model";

export default class Report extends Model {
    resource() {
        return "reports";
    }

    baseURL() {
        return super.baseURL() + "/resourcecenter";
    }
}
